//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';

export default {
  name: 'index',
  props: ['params'],
  metaInfo: {
    title: '等级说明'
  },
  created: async function () {
    await this.getInfo();
  },
  data() {
    return {
      enterprise: this.params.enterprise,
      info: {}
    };
  },
  computed: {},
  filters: {},
  components: {},
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/member/page.vue